import React from 'react';
import { Route, Routes, Navigate } from "react-router-dom";
import Login from '../components/Login';
import Register from '../components/Register';
import PersonalDetailsForm from '../components/Pages/PersonalDetailsForm';
import ProductAuthAdd from '../components/Pages/ProductAuthAdd';
import AddServiceAuth from '../components/Pages/AddServiceAuth';

function AuthRoute(props) {
  return (
    <Routes>
      <Route path='/' element={<Login />} />
      <Route path='/login' element={<Login />} />
      <Route path='/register' element={<Register />} />
      <Route path='/add-personal-detail' element={<PersonalDetailsForm />} />
      <Route path='/add-product' element={<ProductAuthAdd />} />
      <Route path='/add-service' element={<AddServiceAuth />} />
      <Route path='*' element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default AuthRoute;